import { PopoverPlacement } from "@idui/react-popover";
import { Button } from "@mui/material";
import { FC, ReactNode } from "react";

import { useIsMobile } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import { REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS } from "./rebuild-route-dropdown.constants";

interface IRebuildRouteDropdownSubmitButtonProps {
  label: string;
  hint?: string;
  tooltip?: string;
  startIcon: ReactNode;
  isLoading?: boolean;
  isSecondary?: boolean;
  isSkipCacheActive?: boolean;
  onClick: () => void;
}

export const RebuildRouteDropdownSubmitButton: FC<
  IRebuildRouteDropdownSubmitButtonProps
> = ({
  label,
  hint,
  tooltip,
  startIcon,
  isLoading,
  isSecondary,
  isSkipCacheActive,
  onClick,
}) => {
  const { isMobile } = useIsMobile();
  const button = (
    <Button
      className={`rebuild-route-dropdown-submit${
        isSecondary ? " rebuild-route-dropdown-submit--secondary" : ""
      }${
        isSkipCacheActive
          ? " rebuild-route-dropdown-submit--skip-cache-active"
          : ""
      }`}
      variant={isSecondary ? "outlined" : "contained"}
      color="primary"
      fullWidth
      size="medium"
      disabled={isLoading}
      startIcon={startIcon}
      onClick={onClick}
    >
      <span className="rebuild-route-dropdown-submit-copy">
        <span className="rebuild-route-dropdown-submit-title">{label}</span>
        {hint ? (
          <span className="rebuild-route-dropdown-submit-hint">{hint}</span>
        ) : null}
      </span>
    </Button>
  );

  if (!tooltip || isMobile) {
    return button;
  }

  return (
    <FramerTooltip
      content={tooltip}
      placement={PopoverPlacement.top}
      mouseEnterDelay={REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS}
    >
      <span className="rebuild-route-dropdown-submit-tooltip-anchor">
        {button}
      </span>
    </FramerTooltip>
  );
};
